module.exports = "https://static.im-cdn.com/mjc/storefront/Florencia/static/media/Twitter1.41bc5c7a.svg";